/**
 * Playbooks index's loading shape — the route's `pendingComponent`. Already
 * compliant (real chrome + `TableFullSkeleton`), just relocated out of the
 * route per P-05: a skeleton defined in the route can't see the component it
 * mirrors, so it drifts unnoticed.
 */
import {
	Section,
	SectionDescription,
	SectionTitle,
} from '@/features/app-shell/section'

import { TableFullSkeleton } from '@/shared/data-table/components/table-skeleton'

export const PlaybooksSkeleton = () => {
	return (
		<Section>
			<SectionTitle>Playbooks</SectionTitle>
			<SectionDescription>
				Predefined workflows made up of multiple automated actions that work
				together to remediate a security incident. Playbooks can be run manually
				or automatically triggered by mapped policies.
			</SectionDescription>

			<TableFullSkeleton rows={5} withLastUpdated withFilters />
		</Section>
	)
}
